export default {
    login_register: 'Log ind/Registrer',
    booking_confirmation_title: 'Bookingbekræftelse',
    booking_confirmation_body: 'Tak for din booking. Se bekræftelsesoplysninger nedenfor.',
    insurance_requirements_modal_disclaimer: `Ved at foretage denne booking bekræfter jeg: Jeg har ikke haft domme eller færdselsforseelser de seneste 5 år. Jeg har ikke fået et tilbud afvist, en police annulleret eller fornyelse nægtet, eller været pålagt forhøjet præmie eller særlige vilkår af et forsikringsselskab. Jeg er ikke blevet frakendt førerretten. Jeg har ingen verserende tiltaler eller politiefterforskninger. Jeg har ingen domme for tyveri, bedrageri eller uærlighed inden for de sidste 5 år. Jeg lider ikke af nedsat syn eller hørelse (som ikke korrigeres med briller eller høreapparat), hjertelidelse, diabetes, anfald eller anden fysisk eller psykisk svaghed. Jeg har ikke haft nogen ulykker de sidste 5 år. Klik {0} hvis du ikke opfylder disse krav.`,
    insurance_requirements_here: 'her',
    insurance_requirements: 'Jeg har læst og forstået {0}',
    ir: 'Forsikringskrav',
    location: 'Lokation',
    pickup_location: 'Afhentningssted',
    dropoff_location: 'Afleveringssted',
    vehicle: 'Køretøj',
    pickup_and_dropoff: 'Afhentning og aflevering (lokal tid)',
    view_voucher: 'Vis voucher',
    identity_verification_body: 'Du skal verificere din identitet, før du henter køretøjet',
    identity_verification_title: 'Verificer identitet',
    search_again: 'Søg igen',
    refrigerated: 'kølet',
    aircon_lower: 'aircondition',
    aircon: 'Aircondition',
    refrigeration: 'Kølet',
    not_available: 'Drive & Go er i øjeblikket kun tilgængelig for personer med identitets- og kørekortdokumenter fra følgende lande.',
    check_if_included: 'Tjek om dit land er med.',
    included_in_booking: 'Inkluderet i denne booking',
    cdw_with_excess: 'CDW med selvrisiko',
    theft_protection: 'Tyverisikring med selvrisiko',
    risk_reduction: 'Risikoreduktion',
    free_extras: 'Du har ret til to gratis tilvalg <br /> med denne booking.',
    continue: 'Fortsæt',
    luggage_large_short_label: 'L',
    luggage_medium_short_label: 'M',
    luggage_small_short_label: 'S',
    luggage_large_long_label: 'stor',
    luggage_medium_long_label: 'mellem',
    luggage_small_long_label: 'lille',
    fuel_unspecified_label: 'uspecificeret',
    transmission_manual_label: 'Manuel',
    transmission_automatic_label: 'Automatisk',
    make_a_booking: 'Lav en booking',
    pickup_date: 'Afhentningsdato',
    dropoff_date: 'Afleveringsdato',
    driver_age: 'Fører mellem 30 - 65',
    enter_driver_age: 'Angiv førerens alder',
    promo_code: 'Rabatkode',
    search: 'Søg',
    dropoff_date_cannot_be_before_pickup_date: 'Afleveringsdato kan ikke være før afhentningsdato',
    pickup_date_cannot_be_in_the_past: 'Afhentningsdato kan ikke være i fortiden',
    pickup_time_cannot_be_in_the_past: 'Afhentningstid kan ikke være i fortiden',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Afleveringstid skal være senere end afhentningstid, hvis det er samme dag',
    vehicle_filters: 'Køretøjsfiltre',
    reset: 'Nulstil',
    transmission: 'Gearkasse',
    all: 'Alle',
    manual: 'Manuel',
    auto: 'Automat',
    passengers: 'Passagerer',
    vehicle_type: 'Køretøjstype',
    filter: 'Filtrer',
    vehicle_search: 'Køretøjssøgning',
    edit: 'Rediger',
    no_results: 'Ingen resultater matcher dine filtre.',
    small_cars: 'Små biler',
    medium_cars: 'Mellemstore biler',
    large_cars: 'Store biler',
    estate_cars: 'Stationcars',
    suvs: 'SUV',
    mpvs: 'MPV',
    vans: 'Varevogne',
    camper_vans: 'Autocampere',
    premium: 'Premium',
    unspecified: 'uspecificeret',
    large: 'stor',
    medium: 'mellem',
    small: 'lille',
    automatic: 'automatisk',
    you_have_been_refunded: 'Du er blevet refunderet.',
    please_customer_service: 'Kontakt vores kundeservice for at lave en booking.',
    contact_customer_service: 'Kontakt kundeservice',
    booking_failed: 'Din booking kunne ikke behandles denne gang.',
    summary: 'Oversigt',
    reforestation_and_protection: 'Støt genplantning og beskyttelse af regnskoven i hele Costa Rica',
    cost_of_rental: 'Lejeomkostning',
    to_pay_now: 'At betale nu',
    greenheart_donation: 'Green Heart-donation',
    total_cost: 'Samlede lejeomkostninger',
    tc_agreement: 'Jeg har læst og forstået {0}.',
    tc: 'Vilkår',
    receive_offers: 'Jeg vil gerne modtage særtilbud via e-mail.',
    donate: 'Ja, jeg vil donere {amount}',
    pay_now: 'Betal {amount} nu',
    driver_details: 'Førerens oplysninger',
    complete_driver_details: 'Udfyld venligst førerens oplysninger.',
    are_you_the_driver: 'Er du føreren?',
    have_an_account: 'Har du allerede en konto?',
    login: 'Log ind',
    or: 'eller',
    first_name: 'Førerens fornavn',
    last_name: 'Førerens efternavn',
    email: 'E-mailadresse',
    phone_number: 'Mobilnummer',
    unable_to_save_driver_information: 'Kunne ikke gemme førerens oplysninger. Prøv igen.',
    pay_online_now: 'Betal nu',
    day: 'Dag',
    choose_location: 'Vælg lokation',
    location_not_found: 'Vi kunne desværre ikke finde den ønskede lokation.',
    add: 'Tilføj',
    remove: 'Fjern',
    free_extra: 'Gratis tilvalg',
    free: 'GRATIS!',
    fast_track_notice: 'Dokumentbegrænsninger gælder for denne tjeneste. Kun tilgængelig for personer med dokumenter fra',
    complete_booking: 'Fuldfør booking',
    choose_card: 'Vælg et kort eller tilføj et nyt.',
    add_billing_details: 'Tilføj faktureringsoplysninger.',
    card_number: 'Kortnummer',
    card_holder_name: 'Kortindehaverens navn',
    card_exp: 'MM / ÅÅ',
    card_cvc: 'CVC',
    save_card: 'Gem kort?',
    amount_charged: 'Dit kort bliver opkrævet',
    payment_confirmation: 'Bekræft booking og betal',
    payment_methods: 'tilgængelige betalingsmetoder',
    use_saved_card: 'x brug gemt kort',
    use_different_card: '+ brug et andet kort',
    book_now: 'Book nu',
    minimum_age: 'Kun over {age} år',
    excess_liability: 'Selvrisiko',
    security_deposit: 'Depositum',
    fuel_policy: 'Brændstofpolitik',
    like_for_like: 'Lige for lige',
    full_to_full: 'Fuld til fuld',
    miles_per_rental: '{mileage} gratis mil pr. leje',
    km_per_rental: '{mileage} gratis km pr. leje',
    unlimited_mileage: 'Ubegrænset kilometer',
    unlimited_mileage_km: 'Ubegrænsede km',
    non_amendable: 'Kan ikke ændres',
    non_refundable: 'Ikke-refunderbar',
    free_cancellation_until: 'Gratis afbestilling indtil',
    cancellation_in_line_with: 'Afbestilling i overensstemmelse med',
    tcs: 'Vilkår',
    free_extras_on_collection: 'To gratis tilvalg ved afhentning',
    glass_and_tyres_covered: 'Glas og dæk er dækket',
    number_of_passengers: 'Antal passagerer',
    number_of_bags: 'Antal tasker',
    fuel_type: 'Brændstoftype',
    co2: 'CO2',
    book_type: 'Book {type}',
    processing: 'Behandler',
    actual_price: 'Faktisk pris',
    tooltip: 'Pris i {currencyCode} er et estimat baseret på valutakurs; prisen i {currency} er bindende.',
    deposit: 'Depositum',
    pay_online: 'Betal nu',
    pay_online_without_extras: 'Lejepris',
    extras_on_arrival: 'Tilvalg ved ankomst',
    insurance_on_arrival: 'Risikoreduktion - betal ved ankomst',
    insurance_online: 'Risikoreduktion - betal nu',
    extras_online: 'Tilvalg - betal nu',
    green_heart_donation: 'Green Heart-donation',
    why_use_drive_and_go: 'Hvorfor bruge Drive & Go?',
    straight_to_car: 'Direkte til bilen',
    no_queues: 'Ingen køer',
    self_checkout: 'Selvbetjening',
    cant_lose_key: 'Kan ikke miste nøglen',
    online_id_check: 'Online ID-tjek',
    phone_as_key: 'Telefon som nøgle',
    premiumplus_benefits_includes: 'Premium Plus+-fordele er også inkluderet',
    book_drive_go: 'Book Drive & Go',
    distance_allowance: 'Distancegrænse',
    duration: 'Varighed',
    view_more_bookings: 'Vis flere bookinger',
    to_pay_on_arrival: 'At betale ved ankomst',
    pay_on_arrival: 'Betal ved ankomst',
    unlimited: 'Ubegrænset',
    return_date: 'Returdato',
    postcode: 'Postnummer',
    country: 'Land',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go er i øjeblikket kun tilgængelig for personer med identitets- og kørekortdokumenter fra følgende lande:',
        drive_and_go_today: 'Drive & Go-booking i dag!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Hvorfor bruge Drive & Go?',
        straight_to_car: 'Direkte til bilen',
        no_queues: 'Ingen køer',
        self_checkout: 'Selvbetjening',
        cannot_lose_the_key: 'Kan ikke miste nøglen',
        online_id_check: 'Online ID-tjek',
        phone_as_a_key: 'Telefon som nøgle',
        premium_plus_benefits_also_included: 'Premium Plus+-fordele er også inkluderet',
        book_drive_and_go: 'Book Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Telt og udstyr',
        quick_and_easy: 'Hurtig og nem at opstille',
        travel_freedom: 'Rejsefrihed',
        affordable_campervan_alternative: 'Overkommeligt alternativ til autocamper',
        lightweight_and_compact: 'Let og kompakt',
        fully_insured: 'Fuldt forsikret',
    },
    my_bookings: 'Min booking',
    no_bookings: 'Ingen booking',
    my_profile: 'Min profil',
    no_bookings_to_display: 'Ingen booking at vise.',
    search_great_car_rental_deals: 'Find gode billejetilbud til din næste tur.',
    odometer_at_collection: 'Kilometertæller ved afhentning',
    fuel_at_collection: 'Brændstof ved afhentning',
    start_check_in: 'Start check-in',
    start_collection: 'Start afhentning',
    recent_bookings: 'Seneste booking',
    damage: {
        updated_damage_report_submitted: 'En opdateret skaderapport er indsendt. En medarbejder fra kundeservice kontakter dig om nødvendigt.',
        add_additional_damage: 'Tilføj ekstra skade',
        you_may_report_additional_damage_up_to: 'Du kan rapportere yderligere skade op til 24 timer efter afhentning',
        specify_damage: 'Angiv skade',
        please_choose_the_area_and_type_of_damage: 'Vælg område og skadestype',
        type_of_damage: 'Type af skade',
        is_this_more_than_5_cm: 'Er dette mere end 5 cm?',
        please_take_or_select_a_photo: 'Tag eller vælg et foto',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Tag et foto, så skaden er tydelig',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Hvis det er nødvendigt, kan du tilføje et ekstra foto; vælg ikonet for at tilføje',
        save_image: 'Gem billede',
        save_images: 'Gem billeder',
        damage_saved_successfully: 'Skaden blev gemt',
        add_photo: 'Tilføj foto',
    },
    checkout: {
        start_collection: 'Start afhentning',
        collect_vehicle: 'Hent køretøj',
        we_will_let_you_know_the_details: 'Vi fortæller dig placering og detaljer, så du kan finde udlejningsbilen.',
        inspect: 'Inspicer',
        we_will_ask_for_four_photos_from_each_corner: 'Vi beder om fire fotos fra hvert hjørne af køretøjet samt eventuelle nye skader, der ikke allerede er opført.',
        fuel_and_milage: 'Brændstof og kilometer',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Du bekræfter målerstand og brændstof ved starten af lejen.',
        sign: 'Underskriv',
        sign_the_rental_agreement: 'Underskriv lejekontrakten.',
        away_you_go: 'God tur',
        you_are_free_to_take_to_the_road: 'Du er klar til at køre!',
        collect_your_vehicle: 'Hent dit køretøj',
        get_directions: 'Få rutevejledning',
        hide_directions: 'Skjul rutevejledning',
        local_time: 'lokal tid',
        tel: 'Tlf',
        getting_to_the_location: 'Sådan kommer du til stedet',
        get_vehicle_details: 'Hent køretøjsdetaljer',
        view_map: 'Vis kort',
        unlock_vehicle_and_continue: 'Lås køretøjet op og fortsæt',
        unable_to_connect_to_vehicle: 'Kan ikke oprette forbindelse til køretøjet',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Vi kunne ikke oprette forbindelse til køretøjet – kontroller, at du står ved det rigtige køretøj, og prøv igen.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Vi kunne ikke finde køretøjsbookingen. Prøv igen senere.',
        odometer_and_fuel: 'Kilometertæller og brændstof',
        odometer: 'Kilometertæller',
        please_confirm_the_odometer_and_fuel_readings: 'Bekræft om muligt kilometertæller og brændstofstand.',
        the_odometer_field_is_required: 'Feltet kilometertæller er påkrævet',
        and_must_be_greater_than_the_checkout_odometer: 'og skal være højere end kilometertælleren ved check-out',
        confirm: 'Bekræft',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Tag et foto fra hvert hjørne af køretøjet',
        pre_existing_damage: 'Eksisterende skader',
        no_pre_existing_damage: 'Ingen eksisterende skader.',
        new_damage: 'Ny skade',
        add_additional_damage: 'tilføj ekstra skade',
        no_new_damage_to_report: 'Ingen ny skade at rapportere',
        checkout_complete: 'Check-out fuldført',
        start_rental: 'Start leje',
        congratulations_name_it_is_time_to_take_to_the_road: 'Tillykke {customer_name}, det er tid til at komme ud på vejen!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Vi kan ikke fuldføre dit køretøjs check-out.',
        please_do_the_following: 'Gør venligst følgende',
        remove_all_belonging_and_lock_the_vehicle: 'Fjern alle ejendele og lås køretøjet.',
        lock_vehicle: 'Lås køretøj',
        once_you_have_contacted_customer_services: 'Når du har kontaktet kundeservice',
        vehicle_location: 'Køretøjets placering',
        collect_your: 'Hent din',
        from: 'Fra',
        key_in_glove_box: 'din nøgle ligger i handskerummet',

        keyholder: {
            not_detected: 'Nøgle ikke registreret i nøgleholderen',
            not_detected_please_try_again: 'Placer nøglen i nøgleholderen, og prøv igen.',

            not_installed: 'Nøgleholder ikke installeret',
            not_installed_please_contact_customer_service: 'Nøgleholderen er ikke installeret, kontakt kundeservice.',
        },
        keyring: {
            look_up_failed: 'Nøglering kunne ikke findes',
            look_up_failed_please_contact_customer_service: 'Nøglering blev ikke fundet, kontakt kundeservice.',
        },
        key: {
            invalid: 'Nøglen er ugyldig',
            invalid_please_contact_customer_service: 'Din nøgle er ugyldig, kontakt kundeservice.',

            expired: 'Nøglen er udløbet',
            expired__please_contact_customer_service: 'Din nøgle er udløbet, kontakt kundeservice.',
        },
    },
    checkin: {
        start_check_in: 'Start check-in',
        vehicle_location: 'Køretøjets placering',
        tell_us_where_you_have_parked: 'Fortæl os, hvor du har parkeret køretøjet.',
        fuel_and_milage: 'Brændstof og kilometer',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Du bekræfter målerstand og brændstof ved slutningen af lejen.',
        inspect: 'Inspicer',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Vi beder om fire fotos fra hvert hjørne af køretøjet samt eventuelle nye skader under lejen.',
        lock: 'Lås',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Kontroller, at du ikke har efterladt noget, og lås derefter køretøjet.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Fortæl, hvor du har parkeret køretøjet',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Når køretøjet er låst, kan du ikke låse det op igen.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, kontroller at du ikke har efterladt noget, lås køretøjet, og returner den fysiske nøgle til nøgleholderen, hvis det er nødvendigt.',
        lock_vehicle: 'Lås køretøj',
        complete_check_in: 'Afslut check-in',
        inspection: 'Inspektion',
        complete_vehicle_check_in: 'Afslut køretøjs-check-in',
        we_are_unable_to_complete_your_vehicle_check_in: 'Vi kan ikke fuldføre din check-in.',
        please_contact_customer_services: 'Kontakt kundeservice',
        once_you_have_contacted_customer_services: 'Når du har kontaktet kundeservice',
        please_amend_odometer_to_be_greater_than: 'Ret kilometertælleren til at være større end {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Lejekontrakt',
        agreement_between: 'Aftale mellem',
        and: 'og',
        sign_rental_agreement: 'Underskriv lejekontrakt',
        i_have_read_and_understood_the_terms_and_conditions: 'Jeg har læst og forstået vilkårene og accepterer køretøjets stand',
    },
    additional_options: 'Yderligere tilvalg',
    booking_details: 'Bookingoplysninger',
    price_for_x_days: 'Pris for {qty_of_days} dag | Pris for {qty_of_days} dage',
    cancelled: 'Annulleret',
    upcoming: 'Kommende',
    active: 'Aktiv',
    full_insurance_no_deposit: 'Fuldt dækket og intet depositum kræves',
    excess: '{amount} selvrisiko',
    deposit: '{amount} depositum',
    included_daily_distance: '{distance} {unit} pr. dag',
    miles: 'mil',
    kilometers: 'kilometer',
    collection_details_title: 'Afhentningsdetaljer',
    collection_details_not_found: 'Ingen afhentningsdetaljer defineret for denne lokation',
    free_cancellation: 'Gratis afbestilling',
    no_deposit: 'Intet depositum',
    benefit_from: 'Få fordel af',
    for_only_per_day: 'For kun {price} pr. dag',
    upgrade_mee: 'UpgradeMee',
};
